var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnInfoLg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.781 14.246a2.298 2.298 0 11-4.595 0 2.298 2.298 0 014.595 0zm.058 19.761V19.302h-5.515v.919h1.838v13.786h-1.838v.92h7.353v-.92h-1.838zM24 0C10.8 0 .104 10.696.104 23.897.104 37.097 10.8 47.794 24 47.794c13.2 0 23.897-10.696 23.897-23.897C47.898 10.697 37.2 0 24 0zm0 45.806c-12.075 0-21.91-9.822-21.91-21.909 0-12.075 9.823-21.91 21.91-21.91 12.074 0 21.909 9.824 21.909 21.91 0 12.075-9.834 21.91-21.91 21.91z",
    fill: "#FF7D6B"
  })));
}
export default SvgIcnInfoLg;